import { __assign, __awaiter, __generator, __read, __spread, __values } from "tslib";
import React from 'react';
import { app } from '@ekuaibao/whispered';
import { parseAIResultValue, extractIdsFromArray } from '../../../../../components/dynamic/parseAIResult';
import { Modal, message } from '@hose/eui';
import { isFunction } from '@ekuaibao/helpers';
import { TwoToneGeneralAutofill, FilledTipsWarning } from '@hose/eui-icons';
import { uuid } from '@ekuaibao/helpers';
import { fetchAttachment } from '../../../../../components/utils/FetchAttachment';
import { fetchInvoice } from '../../../../../lib/attachment-fetch';
import { parseAsMeta } from '../../../util/parse';
var isDetailsField = function (type) {
    return ['details', "requisitionDetails"].includes(type);
};
export var isValidField = function (item) {
    var _a;
    return (item.hide === false &&
        item.editable === true &&
        ((_a = item.defaultValue) === null || _a === void 0 ? void 0 : _a.type) !== 'formula')
        || item.type === "invoice";
};
export var isValidFieldDataLink = function (item) {
    var _a, _b;
    return ((_a = item.dataType) === null || _a === void 0 ? void 0 : _a.type) === 'list'
        && item.type === 'dataLinkEdits'
        && ["INSERT", "MORE"].includes(item.behaviour)
        && item.hide === false
        && item.editable === true
        && ((_b = item.defaultValue) === null || _b === void 0 ? void 0 : _b.type) !== 'formula';
};
export var buildFieldInfo = function (item, type, isArray) {
    if (isArray === void 0) { isArray = false; }
    return ({
        label: item.label,
        type: type,
        isArray: isArray
    });
};
export var buileFieldFilter = function (item) {
    var _a, _b, _c, _d, _e, _f;
    if (['text', 'date', 'dateRange', 'number', 'money'].includes((_a = item.dataType) === null || _a === void 0 ? void 0 : _a.type)) {
        return buildFieldInfo(item, (_b = item.dataType) === null || _b === void 0 ? void 0 : _b.type);
    }
    if ((_c = item.type) === null || _c === void 0 ? void 0 : _c.startsWith('ref:basedata.Dimension')) {
        return buildFieldInfo(item, item.type.replace(/^ref:/, ''), false);
    }
    if ((_d = item.type) === null || _d === void 0 ? void 0 : _d.startsWith('list:ref:basedata.Dimension')) {
        return buildFieldInfo(item, item.type.replace(/^list:ref:/, '').replace(/:select$/, ''), true);
    }
    if (item.type === 'ref:organization.Staff') {
        return buildFieldInfo(item, 'organization.Staff', false);
    }
    if (item.type === 'list:ref:organization.Staff') {
        return buildFieldInfo(item, 'organization.Staff', true);
    }
    if ((_e = item.type) === null || _e === void 0 ? void 0 : _e.startsWith('ref:basedata.Enum')) {
        return buildFieldInfo(item, item.type.replace('ref:', ''), false);
    }
    if (item.type === 'ref:organization.Department') {
        return buildFieldInfo(item, 'organization.Department', false);
    }
    if (item.type === 'city') {
        return buildFieldInfo(item, 'basedata.city', ((_f = item.field) === null || _f === void 0 ? void 0 : _f.multiple) || false);
    }
    if (item.type === 'payeeInfo') {
        return buildFieldInfo(item, 'payeeInfo', false);
    }
    if (item.type === 'attachments' || item.type === 'aiAttachments') {
        return buildFieldInfo(item, 'attachments', true);
    }
    if (item.type === 'invoice') {
        return buildFieldInfo(item, 'invoice', false);
    }
    if (isDetailsField(item.type)) {
        return buildFieldInfo(item, item.type, true);
    }
    if (item.type === "expenseLinks") {
        return buildFieldInfo(item, 'expenseLinks', true);
    }
    if (item.type === "expenseLink") {
        return buildFieldInfo(item, 'expenseLink', false);
    }
    return null;
};
export var buileFieldFilterDataLink = function (item) {
    var _a, _b, _c, _d, _e, _f;
    if (['text', 'date', 'dateRange', 'number', 'money'].includes(item.type)) {
        return buildFieldInfo(item, item.type);
    }
    if (item.type === 'ref' && ((_a = item.entity) === null || _a === void 0 ? void 0 : _a.startsWith('basedata.Dimension'))) {
        return buildFieldInfo(item, item.entity, false);
    }
    if (item.type === 'ref' && item.entity === 'organization.Staff') {
        return buildFieldInfo(item, 'organization.Staff', false);
    }
    if (item.type === 'list' && ((_b = item === null || item === void 0 ? void 0 : item.elemType) === null || _b === void 0 ? void 0 : _b.type) === 'ref' && ((_c = item === null || item === void 0 ? void 0 : item.elemType) === null || _c === void 0 ? void 0 : _c.entity) === 'organization.Staff') {
        return buildFieldInfo(item, 'organization.Staff', true);
    }
    if (item.type === 'ref' && ((_d = item.entity) === null || _d === void 0 ? void 0 : _d.startsWith('basedata.Enum'))) {
        return buildFieldInfo(item, item.entity, false);
    }
    if (item.type === 'ref' && item.entity === 'organization.Department') {
        return buildFieldInfo(item, 'organization.Department', false);
    }
    if (item.type === 'ref' && item.entity === 'basedata.city') {
        return buildFieldInfo(item, 'basedata.city', true);
    }
    if (item.type === 'ref' && ((_e = item.entity) === null || _e === void 0 ? void 0 : _e.startsWith('datalink.DataLinkEntity'))) {
        return buildFieldInfo(item, item.entity, false);
    }
    if (item.type === 'ref' && ((_f = item.entity) === null || _f === void 0 ? void 0 : _f.startsWith('pay.PayeeInfo'))) {
        return buildFieldInfo(item, item.entity, false);
    }
    return null;
};
export var addAiStyles = function () {
    if (!document.getElementById('ai-styles')) {
        var styleEl = document.createElement('style');
        styleEl.id = 'ai-styles';
        styleEl.textContent = "\n      .ai-filled-field input, \n      .ai-filled-field .ant-select-selector,\n      .ai-filled-field .ant-picker,\n      .ai-filled-field textarea {\n        border: 1px solid var(--eui-primary-pri-500) !important;\n        transition: all 0.3s;\n      }\n      \n      .ai-icon {\n        display: inline-flex;\n        margin-left: 4px;\n        vertical-align: middle;\n        color: var(--eui-primary-pri-500);\n        position: relative;\n        top: -1px;\n      }\n      \n      @keyframes fadeIn {\n        from { opacity: 0; }\n        to { opacity: 1; }\n      }\n      \n      .ai-icon svg {\n        animation: fadeIn 0.5s;\n      }\n    ";
        document.head.appendChild(styleEl);
    }
};
export var renderIconToElement = function (element) {
    try {
        var ReactDOM = require('react-dom');
        ReactDOM.render(React.createElement("div", { style: {
                display: 'flex',
                height: '20px',
                padding: '1px 4px',
                alignItems: 'center',
                gap: '4px',
                borderRadius: '4px',
                background: 'linear-gradient(270deg, #D7CAFF -12.77%, #D7CAFF -12.75%, #E2FCFF 100%), linear-gradient(90deg, #FF8A00 0%, #FF3D00 100%)',
                color: '#4E77FE',
                font: 'var(--eui-font-note-b2)',
            } },
            React.createElement(TwoToneGeneralAutofill, { fontSize: 16 }),
            React.createElement("span", null, "AI\u586B\u5199")), element);
    }
    catch (error) {
        element.innerHTML = "<div style=\"\n      display: flex;\n      height: 20px;\n      padding: 1px 4px;\n      align-items: center;\n      gap: 4px;\n      border-radius: 4px;\n      background: linear-gradient(270deg, #D7CAFF -12.77%, #D7CAFF -12.75%, #E2FCFF 100%), linear-gradient(90deg, #FF8A00 0%, #FF3D00 100%);\n      color: #4E77FE;\n      font: var(--eui-font-note-b2);\n    \">\n      <svg id=\"outlined-general/signature\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" focusable=\"false\" aria-hidden=\"true\" style=\"max-width: 100%; max-height: 100%;\"><path d=\"M8.57155 31.7219C8.67172 31.0677 8.93264 30.4487 9.33091 29.9202L27.1302 6.29967C28.4597 4.53537 30.9677 4.18289 32.732 5.51239L34.7651 7.04441C36.5294 8.37391 36.8819 10.8819 35.5524 12.6462L17.7531 36.2667C17.3548 36.7952 16.8316 37.2167 16.2304 37.4933L10.4155 40.1687C8.96831 40.8345 7.36146 39.6236 7.60261 38.049L8.57155 31.7219Z\" stroke=\"url(#paint0_linear_35_53505)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-dasharray=\"0 0 0 95.33\"><animate attributeType=\"XML\" attributeName=\"stroke-dasharray\" repeatCount=\"1\" dur=\"1s\" values=\"0,0,0,95.3301773071289;            0,47.66508865356445,47.66508865356445,0;            95.3301773071289,0,0,0\" keyTimes=\"0; 0.5; 1\" fill=\"freeze\"></animate></path><path d=\"M35.1234 36.5242L31.4038 35.0762C31.2844 35.0295 31.1823 34.9496 31.1103 34.8467C31.0384 34.7439 31 34.6228 31 34.4988C31 34.3749 31.0384 34.2538 31.1103 34.1509C31.1823 34.0481 31.2844 33.9682 31.4038 33.9215L35.1234 32.4724C35.471 32.3373 35.7414 32.0628 35.8623 31.7196L37.3872 27.4209C37.431 27.2981 37.5136 27.1915 37.6235 27.116C37.7334 27.0406 37.865 27 38 27C38.135 27 38.2666 27.0406 38.3765 27.116C38.4864 27.1915 38.569 27.2981 38.6128 27.4209L40.1366 31.7207C40.2586 32.0628 40.5279 32.3373 40.8766 32.4735L44.5962 33.9215C44.7156 33.9682 44.8177 34.0481 44.8897 34.1509C44.9616 34.2538 45 34.3749 45 34.4988C45 34.6228 44.9616 34.7439 44.8897 34.8467C44.8177 34.9496 44.7156 35.0295 44.5962 35.0762L40.8766 36.5242C40.5279 36.6604 40.2586 36.9338 40.1366 37.277L38.614 41.5768C38.5707 41.7001 38.4883 41.8073 38.3784 41.8832C38.2684 41.9592 38.1365 42 38.0012 42C37.8658 42 37.7339 41.9592 37.6239 41.8832C37.514 41.8073 37.4316 41.7001 37.3883 41.5768L35.8634 37.277C35.8036 37.1079 35.7066 36.9531 35.5792 36.8232C35.4517 36.6933 35.2966 36.5914 35.1246 36.5242H35.1234Z\" stroke=\"url(#paint1_linear_35_53505)\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-dasharray=\"0 0 0 44.734\"><animate attributeType=\"XML\" attributeName=\"stroke-dasharray\" repeatCount=\"1\" dur=\"1s\" values=\"0,0,0,44.734230041503906;            0,22.367115020751953,22.367115020751953,0;            44.734230041503906,0,0,0\" keyTimes=\"0; 0.5; 1\" fill=\"freeze\"></animate></path><path d=\"M5.52955 16.0798L4.52494 15.7089C4.36991 15.6521 4.23709 15.5544 4.14354 15.4283C4.04999 15.3022 4 15.1535 4 15.0013C4 14.8491 4.04999 14.7004 4.14354 14.5743C4.23709 14.4482 4.36991 14.3505 4.52494 14.2937L5.52955 13.9245C6.11157 13.7094 6.56104 13.2755 6.76465 12.7349L7.22182 11.5103C7.27633 11.3617 7.38079 11.2324 7.5204 11.1409C7.66001 11.0493 7.82771 11 7.99976 11C8.17182 11 8.33952 11.0493 8.47913 11.1409C8.61874 11.2324 8.72319 11.3617 8.77771 11.5103L9.23487 12.7349C9.43656 13.2755 9.88796 13.7094 10.47 13.9245L11.4727 14.2937C11.6283 14.3502 11.7617 14.4479 11.8557 14.5742C11.9498 14.7005 12 14.8496 12 15.0022C12 15.1548 11.9498 15.3038 11.8557 15.4302C11.7617 15.5565 11.6283 15.6542 11.4727 15.7107L10.47 16.0781C9.88796 16.2933 9.43656 16.7289 9.23487 17.2677L8.77579 18.4923C8.72084 18.6403 8.61632 18.7689 8.47694 18.8599C8.33756 18.951 8.17034 19 7.9988 19C7.82726 19 7.66004 18.951 7.52066 18.8599C7.38128 18.7689 7.27677 18.6403 7.22182 18.4923L6.76465 17.2677C6.66459 17.0003 6.50249 16.7556 6.28937 16.5504C6.07625 16.3451 5.8171 16.184 5.52955 16.0781V16.0798Z\" fill=\"url(#paint2_linear_35_53505)\" stroke-dasharray=\"0 0 0 24.296\"><animate attributeType=\"XML\" attributeName=\"stroke-dasharray\" repeatCount=\"1\" dur=\"1s\" values=\"0,0,0,24.29570960998535;            0,12.147854804992676,12.147854804992676,0;            24.29570960998535,0,0,0\" keyTimes=\"0; 0.5; 1\" fill=\"freeze\"></animate></path><circle cx=\"25\" cy=\"41\" r=\"2\" fill=\"url(#paint3_linear_35_53505)\" stroke-dasharray=\"0 0 0 11.314\"><animate attributeType=\"XML\" attributeName=\"stroke-dasharray\" repeatCount=\"1\" dur=\"1s\" values=\"0,0,0,11.313708305358887;            0,5.656854152679443,5.656854152679443,0;            11.313708305358887,0,0,0\" keyTimes=\"0; 0.5; 1\" fill=\"freeze\"></animate></circle><defs><linearGradient id=\"paint0_linear_35_53505\" x1=\"5.80318\" y1=\"41.9975\" x2=\"42.8162\" y2=\"18.7391\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9E80FF\"></stop><stop offset=\"1\" stop-color=\"#48DCDC\"></stop></linearGradient><linearGradient id=\"paint1_linear_35_53505\" x1=\"30.6957\" y1=\"33.331\" x2=\"45.3479\" y2=\"34.569\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9E80FF\"></stop><stop offset=\"1\" stop-color=\"#48DCDC\"></stop></linearGradient><linearGradient id=\"paint2_linear_35_53505\" x1=\"3.82609\" y1=\"14.3765\" x2=\"12.19\" y2=\"15.1337\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9E80FF\"></stop><stop offset=\"1\" stop-color=\"#48DCDC\"></stop></linearGradient><linearGradient id=\"paint3_linear_35_53505\" x1=\"22.913\" y1=\"40.6883\" x2=\"27.095\" y2=\"41.0668\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9E80FF\"></stop><stop offset=\"1\" stop-color=\"#48DCDC\"></stop></linearGradient></defs></svg>\n      <span>AI\u586B\u5199</span>\n    </div>";
    }
};
export var addAiIconAndHighlight = function (fieldName, feeDetailId) {
    try {
        var domkey = feeDetailId ? "#FeeDetailView #" + fieldName : "#" + fieldName;
        var iconContainerId = feeDetailId ? "FeeDetailView-" + fieldName + "-ai-icon" : fieldName + "-ai-icon";
        var fieldElement = document.querySelector(domkey);
        if (!fieldElement)
            return;
        var labelElement = fieldElement.querySelector('.ant-form-item-label label');
        var dataLinkFieldElement = fieldElement.querySelector('.risk-warning-label');
        if (!labelElement && !dataLinkFieldElement)
            return;
        if (!document.getElementById(iconContainerId)) {
            var iconContainer = document.createElement('span');
            iconContainer.id = iconContainerId;
            iconContainer.className = 'ai-icon';
            renderIconToElement(iconContainer);
            labelElement && labelElement.appendChild(iconContainer);
            dataLinkFieldElement && dataLinkFieldElement.appendChild(iconContainer);
        }
    }
    catch (error) {
        console.error('添加AI图标失败:', error);
    }
};
export var parseDataLinkForm = function (result, typeMap, template, arrayMapForLabel) {
    if (typeMap === void 0) { typeMap = {}; }
    if (arrayMapForLabel === void 0) { arrayMapForLabel = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var _a, fields, id, subTypeId, behaviour, showTemplateId, importMode, res, items, valueArray;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = template.referenceData, fields = _a.fields, id = _a.id;
                    subTypeId = template.subTypeId, behaviour = template.behaviour, showTemplateId = template.showTemplateId, importMode = template.importMode;
                    console.log('parseDataLinkForm result', result, typeMap, arrayMapForLabel, fields);
                    return [4, app.invokeService('@bills:get:getDataLinkEditTemplate', {
                            id: id,
                            type: ["INSERT", "MORE"].includes(behaviour),
                            tableTemplateId: showTemplateId
                        })];
                case 1:
                    res = _b.sent();
                    items = subTypeId ? res.items.filter(function (i) { var _a; return ((_a = i === null || i === void 0 ? void 0 : i.entity) === null || _a === void 0 ? void 0 : _a.id) === subTypeId; }) : res.items;
                    if (!Array.isArray(result)) {
                        if (typeof result === 'object' && result !== null) {
                            result = [result];
                        }
                        else {
                            return [2, []];
                        }
                    }
                    valueArray = result.map(function (item) {
                        var _a;
                        var valueItem = {
                            dataLinkForm: {},
                            dataLinkId: null,
                            dataLinkTemplateId: (_a = items[0]) === null || _a === void 0 ? void 0 : _a.templateId
                        };
                        var fieldsMapArray = Object.keys(item).map(function (key) {
                            var field = fields.find(function (item) { return item.label === key; });
                            if (field && field.name) {
                                var val = item[key];
                                var type = typeMap[key];
                                var isArray = arrayMapForLabel[key];
                                if (!val)
                                    return null;
                                if (type === 'dateRange' && (!(val === null || val === void 0 ? void 0 : val.start) && !(val === null || val === void 0 ? void 0 : val.end))) {
                                    return null;
                                }
                                var value = void 0;
                                if (isArray && ((type === null || type === void 0 ? void 0 : type.startsWith('basedata.Dimension')) ||
                                    ['organization.Staff', 'basedata.Dimension', 'basedata.city'].includes(type))) {
                                    value = extractIdsFromArray(val);
                                }
                                else if (!(arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key]) && (['basedata.Dimension', 'organization.Staff', 'organization.Department', 'payeeInfo'].includes(type) || (type === null || type === void 0 ? void 0 : type.startsWith('basedata.Enum')) || (type === null || type === void 0 ? void 0 : type.startsWith('basedata.Dimension')) || (type === null || type === void 0 ? void 0 : type.startsWith('datalink.DataLinkEntity')))) {
                                    value = val === null || val === void 0 ? void 0 : val.id;
                                }
                                else {
                                    value = parseAIResultValue(val, type);
                                }
                                if (!value || (value === null || value === void 0 ? void 0 : value.length) === 0)
                                    return null;
                                return {
                                    key: field.name,
                                    value: value,
                                };
                            }
                            return null;
                        }).filter(Boolean);
                        console.log('fieldsMapArray', fieldsMapArray, valueItem);
                        fieldsMapArray.forEach(function (item) {
                            valueItem.dataLinkForm[item.key] = item.value;
                        });
                        return valueItem;
                    });
                    if (importMode === "SINGLE") {
                        return [2, valueArray === null || valueArray === void 0 ? void 0 : valueArray.slice(0, 1)];
                    }
                    return [2, valueArray];
            }
        });
    });
};
export var parseDetailsForm = function (detailsData, feeTypeMap, formSpecificationId) {
    if (feeTypeMap === void 0) { feeTypeMap = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var CORPORATE_PAYMENT_ENHANCED, newDetailsData, processedDetails;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log('parseDetailsForm detailsData', detailsData, feeTypeMap);
                    CORPORATE_PAYMENT_ENHANCED = (_a = app.getState()['@common'].powers) === null || _a === void 0 ? void 0 : _a.CORPORATE_PAYMENT_ENHANCED;
                    if (!Array.isArray(detailsData) || detailsData.length === 0) {
                        return [2, []];
                    }
                    return [4, fetchInvoice(detailsData, '', true)];
                case 1:
                    newDetailsData = _b.sent();
                    return [4, Promise.all(newDetailsData.map(function (item, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var feeType, specificationId, spec, err_1, feeDate, attachmentsFromInvoiceForm, _a, detail, error_1;
                            var _b, _c, _d, _e, _f, _g, _h;
                            return __generator(this, function (_j) {
                                switch (_j.label) {
                                    case 0:
                                        _j.trys.push([0, 8, , 9]);
                                        feeType = { id: item.feeTypeId };
                                        if (feeTypeMap === null || feeTypeMap === void 0 ? void 0 : feeTypeMap[item.feeTypeId]) {
                                            feeType = feeTypeMap === null || feeTypeMap === void 0 ? void 0 : feeTypeMap[item.feeTypeId];
                                        }
                                        specificationId = item.specificationId;
                                        if (!(typeof specificationId === 'string')) return [3, 4];
                                        _j.label = 1;
                                    case 1:
                                        _j.trys.push([1, 3, , 4]);
                                        return [4, app.invokeService('@bills:get:Specifications', [specificationId], undefined, CORPORATE_PAYMENT_ENHANCED ? {
                                                formSpecificationId: formSpecificationId
                                            } : {})];
                                    case 2:
                                        spec = _j.sent();
                                        specificationId = ((_b = spec === null || spec === void 0 ? void 0 : spec.items) === null || _b === void 0 ? void 0 : _b[0]) || { id: specificationId, components: [] };
                                        return [3, 4];
                                    case 3:
                                        err_1 = _j.sent();
                                        console.warn('获取规范信息失败:', err_1);
                                        specificationId = { id: specificationId, components: [] };
                                        return [3, 4];
                                    case 4:
                                        feeDate = (_c = item.feeTypeForm) === null || _c === void 0 ? void 0 : _c.feeDate;
                                        if (typeof feeDate === 'string') {
                                            feeDate = new Date(feeDate).getTime();
                                        }
                                        else if (!feeDate) {
                                            feeDate = Date.now();
                                        }
                                        if (!((_e = (_d = item.feeTypeForm) === null || _d === void 0 ? void 0 : _d.invoiceForm) === null || _e === void 0 ? void 0 : _e.attachments)) return [3, 6];
                                        return [4, fetchAttachment((_g = (_f = item.feeTypeForm) === null || _f === void 0 ? void 0 : _f.invoiceForm) === null || _g === void 0 ? void 0 : _g.attachments)];
                                    case 5:
                                        _a = _j.sent();
                                        return [3, 7];
                                    case 6:
                                        _a = undefined;
                                        _j.label = 7;
                                    case 7:
                                        attachmentsFromInvoiceForm = _a;
                                        detail = {
                                            fromAIChat: true,
                                            idx: index,
                                            feeTypeId: feeType,
                                            specificationId: specificationId,
                                            feeTypeForm: __assign(__assign({}, item.feeTypeForm), { detailId: uuid(14), feeDate: feeDate, amount: ((_h = item.feeTypeForm) === null || _h === void 0 ? void 0 : _h.amount) ? __assign(__assign({}, item.feeTypeForm.amount), { standard: String(item.feeTypeForm.amount.standard || '0.00') }) : {
                                                    standard: '0.00',
                                                    standardUnit: '元',
                                                    standardScale: 2,
                                                    standardSymbol: '¥',
                                                    standardNumCode: '156',
                                                    standardStrCode: 'CNY'
                                                } }),
                                            errorMsg: {},
                                        };
                                        if (attachmentsFromInvoiceForm) {
                                            detail.feeTypeForm.invoiceForm.attachments = attachmentsFromInvoiceForm;
                                        }
                                        return [2, detail];
                                    case 8:
                                        error_1 = _j.sent();
                                        console.error('处理费用明细失败:', error_1, item);
                                        return [2, null];
                                    case 9: return [2];
                                }
                            });
                        }); }))];
                case 2:
                    processedDetails = _b.sent();
                    return [2, processedDetails.filter(Boolean)];
            }
        });
    });
};
export var addDetailsToForm = function (bus, detailsData, feeTypeMap, formSpecificationId) {
    if (feeTypeMap === void 0) { feeTypeMap = {}; }
    return __awaiter(void 0, void 0, Promise, function () {
        var currentFormValues, currentDetails_1, newDetails, allDetails, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4, bus.getFieldsValue()];
                case 1:
                    currentFormValues = _a.sent();
                    currentDetails_1 = currentFormValues.details || [];
                    return [4, parseDetailsForm(detailsData, feeTypeMap, formSpecificationId)];
                case 2:
                    newDetails = _a.sent();
                    if (newDetails.length === 0) {
                        console.warn('没有有效的费用明细数据');
                        return [2, false];
                    }
                    allDetails = __spread(currentDetails_1, newDetails.map(function (detail, index) { return (__assign(__assign({}, detail), { idx: currentDetails_1.length + index })); }));
                    bus.setFieldsValue({
                        details: allDetails
                    });
                    console.log('费用明细添加成功:', allDetails);
                    return [2, true];
                case 3:
                    error_2 = _a.sent();
                    console.error('添加费用明细失败:', error_2);
                    return [2, false];
                case 4: return [2];
            }
        });
    });
};
export var handleApplyAIResult = function (_a) {
    var bus = _a.bus, _b = _a.aiFilledFields, aiFilledFields = _b === void 0 ? {} : _b, setAiFilledFields = _a.setAiFilledFields, _c = _a.result, result = _c === void 0 ? {} : _c, _d = _a.components, components = _d === void 0 ? [] : _d, _e = _a.noApply, noApply = _e === void 0 ? false : _e, formSpecificationId = _a.formSpecificationId;
    return __awaiter(void 0, void 0, Promise, function () {
        var fields, datalinkFieldMap, dataLinkTypeMap, typeMap, arrayMapForLabel, fieldsValue, _f, fieldsToProcess, processedFields, _loop_1, fieldsToProcess_1, fieldsToProcess_1_1, fieldInfo, e_1_1, aiResult, processedFields_1, processedFields_1_1, item, aiValue, newAiFilledFields, detailsField, feeTypesData, feeTypeMap_1, currentFormValues, _g, currentDetails_2, newDetails, detailRepeated, onOk_1, detailRepeatedText_1;
        var e_1, _h, e_2, _j;
        var _k, _l, _m, _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    fields = components
                        .filter(isValidField)
                        .map(buileFieldFilter)
                        .filter(Boolean);
                    datalinkFieldMap = {};
                    components
                        .filter(isValidFieldDataLink)
                        .forEach(function (item) {
                        if (item.referenceData && typeof item.referenceData === 'object') {
                            datalinkFieldMap[item.label.trim()] = item.referenceData.fields
                                .filter(function (item) { return !item.formula; })
                                .map(buileFieldFilterDataLink)
                                .filter(Boolean);
                        }
                    });
                    dataLinkTypeMap = {};
                    Object.keys(datalinkFieldMap).forEach(function (key) {
                        dataLinkTypeMap[key] = 'list:dataLinkEdits';
                    });
                    typeMap = fields.reduce(function (acc, item) {
                        acc[item.label] = item.type;
                        return acc;
                    }, dataLinkTypeMap);
                    arrayMapForLabel = (_k = fields === null || fields === void 0 ? void 0 : fields.reduce) === null || _k === void 0 ? void 0 : _k.call(fields, function (acc, item) {
                        acc[item.label] = item.isArray;
                        return acc;
                    }, {});
                    if (!bus) return [3, 2];
                    return [4, bus.getFieldsValue()];
                case 1:
                    _f = (_p.sent());
                    return [3, 3];
                case 2:
                    _f = {};
                    _p.label = 3;
                case 3:
                    fieldsValue = _f;
                    fieldsToProcess = Object.keys(result).map(function (key) {
                        var _a, _b;
                        var component = components.filter(isValidField).find(function (item) { return item.label.trim() === key; });
                        if (!component || !component.field)
                            return null;
                        var fieldValue = fieldsValue === null || fieldsValue === void 0 ? void 0 : fieldsValue[component.field];
                        var type = typeMap === null || typeMap === void 0 ? void 0 : typeMap[key];
                        var noValue = !fieldValue;
                        if (type === 'list:dataLinkEdits' && Array.isArray(fieldValue)) {
                            noValue = !(((_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.filter(function (item) {
                                var formValues = Object.values((item === null || item === void 0 ? void 0 : item.dataLinkForm) || {});
                                return formValues.some(function (value) {
                                    if (value === null || value === undefined)
                                        return false;
                                    if (typeof value === 'boolean')
                                        return value;
                                    if (Array.isArray(value))
                                        return value.length > 0;
                                    if (typeof value === 'object')
                                        return Object.keys(value).length > 0;
                                    return value !== '';
                                });
                            })) === null || _a === void 0 ? void 0 : _a.length) > 0);
                        }
                        if (type === 'organization.Staff' && (arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key])) {
                            noValue = !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length);
                        }
                        if ((type === null || type === void 0 ? void 0 : type.startsWith('basedata.Dimension')) && (arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key])) {
                            noValue = !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length);
                        }
                        if (type === 'payeeInfo') {
                            noValue = !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.id);
                        }
                        if (type === 'attachments') {
                            noValue = !(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length);
                        }
                        if (isDetailsField(type)) {
                            noValue = true;
                        }
                        if (!noValue)
                            return null;
                        var value = result[key];
                        if (!value || (value === null || value === void 0 ? void 0 : value.length) === 0)
                            return null;
                        if (type === 'dateRange' && (!(value === null || value === void 0 ? void 0 : value.start) && !(value === null || value === void 0 ? void 0 : value.end))) {
                            return null;
                        }
                        if (type === 'list:dataLinkEdits' && Array.isArray(value)) {
                            value = value.filter(function (item) { return Object.values(item).filter((function (valueItem) {
                                var _a, _b;
                                if (valueItem === null || valueItem === undefined)
                                    return false;
                                if (typeof valueItem === 'boolean')
                                    return valueItem;
                                if (Array.isArray(valueItem))
                                    return valueItem.length > 0;
                                if (typeof valueItem === 'object')
                                    return ((_b = (_a = Object.values(valueItem)) === null || _a === void 0 ? void 0 : _a.filter(Boolean)) === null || _b === void 0 ? void 0 : _b.length) > 0;
                                return valueItem !== '';
                            })).filter(Boolean).length > 0; });
                            value = value.map(function (item) {
                                var res = __assign({}, item);
                                Object.keys(res).forEach(function (resKey) {
                                    var _a, _b;
                                    var resValue = res[resKey];
                                    if (Array.isArray(resValue)) {
                                        var finalVal = (_b = (_a = resValue.filter(function (item) { return !(item && typeof item === 'object' && Object.keys(item).length === 0); })) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item === null || item === void 0 ? void 0 : item.name; })) === null || _b === void 0 ? void 0 : _b.filter(Boolean);
                                        if (finalVal.length === 0) {
                                            delete res[resKey];
                                        }
                                    }
                                    if (resValue && typeof resValue === 'object' && !Array.isArray(resValue) && Object.values(resValue).filter(Boolean).length === 0) {
                                        delete res[resKey];
                                    }
                                });
                                return res;
                            });
                            if (value.length === 0)
                                return null;
                        }
                        if (!(arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key]) && type === 'basedata.city') {
                            if (typeof value === 'string') {
                                try {
                                    var valueJSON = (_b = JSON.parse(value)) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.key; });
                                    if (valueJSON.length === 0)
                                        return null;
                                    value = JSON.stringify(valueJSON);
                                }
                                catch (_c) {
                                    return null;
                                }
                            }
                        }
                        if (!(arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key]) && (['basedata.Dimension', 'organization.Staff', 'organization.Department', 'payeeInfo'].includes(type) || (type === null || type === void 0 ? void 0 : type.startsWith('basedata.Enum')) || (type === null || type === void 0 ? void 0 : type.startsWith('basedata.Dimension')))) {
                            value = value === null || value === void 0 ? void 0 : value.id;
                        }
                        if ((arrayMapForLabel === null || arrayMapForLabel === void 0 ? void 0 : arrayMapForLabel[key]) && ((type === null || type === void 0 ? void 0 : type.startsWith('basedata.Dimension')) ||
                            ['organization.Staff', 'basedata.Dimension', 'basedata.city'].includes(type))) {
                            value = extractIdsFromArray(value);
                        }
                        if (!value || (value === null || value === void 0 ? void 0 : value.length) === 0)
                            return null;
                        return {
                            field: component.field,
                            value: value,
                            type: type,
                            component: component,
                            key: key
                        };
                    }).filter(Boolean);
                    processedFields = [];
                    _loop_1 = function (fieldInfo) {
                        var finalValue, childMap_1, arrayMapForLabel_1, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    finalValue = fieldInfo.value;
                                    if (!(fieldInfo.type === 'list:dataLinkEdits')) return [3, 2];
                                    childMap_1 = {};
                                    arrayMapForLabel_1 = {};
                                    (_l = datalinkFieldMap[fieldInfo.key]) === null || _l === void 0 ? void 0 : _l.forEach(function (item) {
                                        childMap_1[item.label] = item.type;
                                        arrayMapForLabel_1[item.label] = item.isArray;
                                    });
                                    console.log(finalValue, result[fieldInfo.key]);
                                    return [4, parseDataLinkForm(finalValue, childMap_1, fieldInfo.component, arrayMapForLabel_1)];
                                case 1:
                                    finalValue = _a.sent();
                                    _a.label = 2;
                                case 2:
                                    processedFields.push({
                                        field: fieldInfo.field,
                                        value: finalValue,
                                        type: fieldInfo.type
                                    });
                                    return [3, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error("\u5904\u7406\u5B57\u6BB5 " + fieldInfo.field + " \u65F6\u51FA\u9519:", error_3);
                                    return [3, 4];
                                case 4: return [2];
                            }
                        });
                    };
                    _p.label = 4;
                case 4:
                    _p.trys.push([4, 9, 10, 11]);
                    fieldsToProcess_1 = __values(fieldsToProcess), fieldsToProcess_1_1 = fieldsToProcess_1.next();
                    _p.label = 5;
                case 5:
                    if (!!fieldsToProcess_1_1.done) return [3, 8];
                    fieldInfo = fieldsToProcess_1_1.value;
                    return [5, _loop_1(fieldInfo)];
                case 6:
                    _p.sent();
                    _p.label = 7;
                case 7:
                    fieldsToProcess_1_1 = fieldsToProcess_1.next();
                    return [3, 5];
                case 8: return [3, 11];
                case 9:
                    e_1_1 = _p.sent();
                    e_1 = { error: e_1_1 };
                    return [3, 11];
                case 10:
                    try {
                        if (fieldsToProcess_1_1 && !fieldsToProcess_1_1.done && (_h = fieldsToProcess_1.return)) _h.call(fieldsToProcess_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7];
                case 11:
                    console.log('handleApplyAIResult processedFields', processedFields);
                    if (noApply) {
                        aiResult = {};
                        try {
                            for (processedFields_1 = __values(processedFields), processedFields_1_1 = processedFields_1.next(); !processedFields_1_1.done; processedFields_1_1 = processedFields_1.next()) {
                                item = processedFields_1_1.value;
                                aiValue = void 0;
                                if (!item.type) {
                                    continue;
                                }
                                if (isDetailsField(item.type)) {
                                    aiValue = item.value;
                                }
                                else {
                                    aiValue = parseAIResultValue(item.value, item.type);
                                }
                                aiResult[item.field] = aiValue;
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (processedFields_1_1 && !processedFields_1_1.done && (_j = processedFields_1.return)) _j.call(processedFields_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2, Promise.resolve(aiResult)];
                    }
                    if (processedFields.length === 0) {
                        Modal.warning({
                            title: i18n.get('请重试'),
                            content: i18n.get('当前AI 提取字段已被填写，请删除字段内容后重试'),
                            okText: i18n.get('知道了'),
                        });
                        return [2, aiFilledFields];
                    }
                    addAiStyles();
                    newAiFilledFields = __assign({}, aiFilledFields);
                    detailsField = processedFields.find(function (item) { return isDetailsField(item.type); });
                    if (!(((_m = detailsField === null || detailsField === void 0 ? void 0 : detailsField.value) === null || _m === void 0 ? void 0 : _m.length) > 0)) return [3, 20];
                    return [4, app.dataLoader('@common.feetypes').load()];
                case 12:
                    feeTypesData = _p.sent();
                    feeTypeMap_1 = feeTypesData === null || feeTypesData === void 0 ? void 0 : feeTypesData.map;
                    if (!bus) return [3, 14];
                    return [4, bus.getFieldsValue()];
                case 13:
                    _g = (_p.sent());
                    return [3, 15];
                case 14:
                    _g = {};
                    _p.label = 15;
                case 15:
                    currentFormValues = _g;
                    currentDetails_2 = currentFormValues.details || [];
                    return [4, parseDetailsForm(detailsField.value, feeTypeMap_1)];
                case 16:
                    newDetails = _p.sent();
                    detailRepeated = newDetails.filter(function (it) {
                        return currentDetails_2.some(function (item) { var _a, _b, _c, _d, _e, _f; return ((_a = item.feeTypeId) === null || _a === void 0 ? void 0 : _a.id) === ((_b = it.feeTypeId) === null || _b === void 0 ? void 0 : _b.id) && ((_d = (_c = item.feeTypeForm) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.standard) === ((_f = (_e = it.feeTypeForm) === null || _e === void 0 ? void 0 : _e.amount) === null || _f === void 0 ? void 0 : _f.standard); });
                    }).map(function (it) {
                        var _a, _b;
                        return {
                            name: (_a = it.feeTypeId) === null || _a === void 0 ? void 0 : _a.name,
                            amount: (_b = it.feeTypeForm) === null || _b === void 0 ? void 0 : _b.amount
                        };
                    });
                    onOk_1 = function () { return __awaiter(void 0, void 0, void 0, function () {
                        var success, error_4;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, addDetailsToForm(bus, detailsField.value, feeTypeMap_1, formSpecificationId)];
                                case 1:
                                    success = _a.sent();
                                    if (success) {
                                        console.log('费用明细添加成功');
                                        addAiIconAndHighlight('details');
                                    }
                                    return [3, 3];
                                case 2:
                                    error_4 = _a.sent();
                                    console.error('处理费用明细失败:', error_4);
                                    return [3, 3];
                                case 3: return [2];
                            }
                        });
                    }); };
                    if (!(detailRepeated.length > 0)) return [3, 18];
                    detailRepeatedText_1 = (_o = detailRepeated.reduce) === null || _o === void 0 ? void 0 : _o.call(detailRepeated, function (acc, item) {
                        var _a, _b;
                        acc += "\u300C" + item.name + ((_a = item.amount) === null || _a === void 0 ? void 0 : _a.standard) + ((_b = item.amount) === null || _b === void 0 ? void 0 : _b.standardUnit) + "\u300D";
                        return acc;
                    }, '');
                    return [4, new Promise(function (resolve) {
                            Modal.confirm({
                                title: '是否创建新的费用明细数据？',
                                icon: React.createElement(FilledTipsWarning, null),
                                content: "\u5F53\u524D\u5355\u636E\u5DF2\u6709" + detailRepeatedText_1 + "\u7684\u8D39\u7528\u660E\u7EC6\uFF0C\u662F\u5426\u521B\u5EFA\u65B0\u7684\u8D39\u7528\u660E\u7EC6\u6570\u636E\uFF1F",
                                okText: '重新创建',
                                cancelText: '取消创建',
                                onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, onOk_1()];
                                            case 1:
                                                _a.sent();
                                                resolve(true);
                                                return [2];
                                        }
                                    });
                                }); },
                                onCancel: function () {
                                    resolve(false);
                                }
                            });
                        })];
                case 17:
                    _p.sent();
                    return [3, 20];
                case 18: return [4, onOk_1()];
                case 19:
                    _p.sent();
                    _p.label = 20;
                case 20: return [2, new Promise(function (resolve) {
                        setTimeout(function () {
                            processedFields.forEach(function (item) {
                                var _a;
                                if (isDetailsField(item.type)) {
                                    return;
                                }
                                try {
                                    var aiValue = parseAIResultValue(item.value, item.type);
                                    bus.setFieldsValue((_a = {},
                                        _a[item.field] = aiValue,
                                        _a));
                                    newAiFilledFields[item.field] = aiValue;
                                    if (aiValue) {
                                        addAiIconAndHighlight(item.field);
                                    }
                                }
                                catch (error) {
                                    console.error("\u8BBE\u7F6E\u5B57\u6BB5 " + item.field + " \u65F6\u51FA\u9519:", error);
                                }
                            });
                            bus.setValidateLevel(0);
                            isFunction(bus === null || bus === void 0 ? void 0 : bus.getValueWithValidate) && (bus === null || bus === void 0 ? void 0 : bus.getValueWithValidate(processedFields.map(function (item) { return item.field; })).then(function (res) {
                                console.log('handleApplyAIResult Validate', res);
                            }).catch(function (err) {
                                console.log('handleApplyAIResult err', err);
                            }));
                            message.success(i18n.get('AI填写成功，请查看'));
                            if (setAiFilledFields) {
                                setAiFilledFields(newAiFilledFields);
                            }
                            resolve(newAiFilledFields);
                        }, 100);
                    })];
            }
        });
    });
};
export var removeAiMarkForField = function (fieldName, feeDetailId) {
    try {
        var iconElement = document.querySelector("#" + (feeDetailId ? "FeeDetailView-" + fieldName + "-ai-icon" : fieldName + "-ai-icon") + " ");
        if (iconElement) {
            iconElement.remove();
        }
    }
    catch (error) {
        console.error('移除AI标记失败:', error);
    }
};
export var addCustomDetailsToForm = function (detailsData, bus) { return __awaiter(void 0, void 0, Promise, function () {
    var formBus, feeTypesData, feeTypeMap, success, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                formBus = bus;
                if (!formBus && window.billBus) {
                    formBus = {
                        getFieldsValue: function () { return window.billBus.getFieldsValue(); },
                        setFieldsValue: function (values) { return window.billBus.setFieldsValue(values); },
                        setValidateLevel: function (level) { var _a, _b; return (_b = (_a = window.billBus).setValidateLevel) === null || _b === void 0 ? void 0 : _b.call(_a, level); }
                    };
                }
                if (!formBus) {
                    console.error('无法获取表单总线');
                    return [2, false];
                }
                return [4, app.dataLoader('@common.feetypes').load()];
            case 1:
                feeTypesData = _a.sent();
                feeTypeMap = feeTypesData === null || feeTypesData === void 0 ? void 0 : feeTypesData.map;
                return [4, addDetailsToForm(formBus, detailsData, feeTypeMap)];
            case 2:
                success = _a.sent();
                if (success) {
                    message.success('费用明细添加成功');
                    addAiIconAndHighlight('details');
                    return [2, true];
                }
                else {
                    message.error('费用明细添加失败');
                    return [2, false];
                }
                return [3, 4];
            case 3:
                error_5 = _a.sent();
                console.error('添加自定义费用明细失败:', error_5);
                message.error('添加费用明细失败');
                return [2, false];
            case 4: return [2];
        }
    });
}); };
export var addDetailsFromAIResult = function (detailsData) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, addCustomDetailsToForm(detailsData)];
    });
}); };
export var formatDataForCreateBills = function (datas, specifications) { return __awaiter(void 0, void 0, void 0, function () {
    var finalDatas, baseDataProperties, userinfo, submitterId, _loop_2, datas_1, datas_1_1, data, e_3_1;
    var e_3, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!datas || !Array.isArray(datas))
                    return [2, []];
                finalDatas = [];
                baseDataProperties = app.getState('@common.globalFields.data');
                userinfo = app.getState()['@common'].userinfo;
                submitterId = (_b = userinfo === null || userinfo === void 0 ? void 0 : userinfo.staff) === null || _b === void 0 ? void 0 : _b.id;
                _loop_2 = function (data) {
                    var specification, components, form;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                specification = specifications.find(function (item) { return item.id === data.specificationId; });
                                components = parseAsMeta(specification, baseDataProperties);
                                return [4, handleApplyAIResult({
                                        result: data,
                                        components: components,
                                        noApply: true,
                                        formSpecificationId: specification.id
                                    })];
                            case 1:
                                form = _a.sent();
                                finalDatas.push({
                                    name: "freeflow.edit",
                                    form: __assign({ submitterId: submitterId, specificationId: data.specificationId }, form),
                                    aiFilledFields: form
                                });
                                return [2];
                        }
                    });
                };
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, 7, 8]);
                datas_1 = __values(datas), datas_1_1 = datas_1.next();
                _c.label = 2;
            case 2:
                if (!!datas_1_1.done) return [3, 5];
                data = datas_1_1.value;
                return [5, _loop_2(data)];
            case 3:
                _c.sent();
                _c.label = 4;
            case 4:
                datas_1_1 = datas_1.next();
                return [3, 2];
            case 5: return [3, 8];
            case 6:
                e_3_1 = _c.sent();
                e_3 = { error: e_3_1 };
                return [3, 8];
            case 7:
                try {
                    if (datas_1_1 && !datas_1_1.done && (_a = datas_1.return)) _a.call(datas_1);
                }
                finally { if (e_3) throw e_3.error; }
                return [7];
            case 8: return [2, finalDatas];
        }
    });
}); };
